import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import SessionService from './CacheService';
import GetUserSession from '../graphql/getUserSession';

const UserSession = (props) => {
    const { children, fetchPolicy, typeCache } = props;

    if (typeCache) {
        const [result, setResult] = useState(null);

        const updateSession = () => {
            SessionService.GetSession().then((res) => {
                setResult(res);
            });
        };

        useEffect(() => {
            updateSession();
        }, [children]);

        if (!result) return '';

        const { loading, data, refetch } = result;
        const salesChannels = data ? get(data, 'getUserInfo.salesChannels', []) : [];

        return children({
            ...props,
            loading,
            session: data.getUserInfo,
            email: get(data.getUserInfo, 'email', null),
            resources: get(data.getUserInfo, 'resources', []),
            groups: get(data.getUserInfo, 'groups'),
            idBols: get(data.getUserInfo, 'idBols'),
            salesChannels,
            refetch
        });
    } else {
        return (
            <GetUserSession fetchPolicy={fetchPolicy}>
                {({ loading, data, salesChannels, refetch }) => children({
                    ...props,
                    loading,
                    session: data,
                    email: get(data, 'email'),
                    resources: get(data, 'resources'),
                    groups: get(data, 'groups'),
                    idBols: get(data, 'idBols'),
                    salesChannels,
                    refetch
                })}
            </GetUserSession>
        );
    }
};

UserSession.propTypes = {
    children: PropTypes.any
};

export default UserSession;
